import React from "react"
import { useTranslation } from "react-i18next"

import { useModal } from "hooks"
import { operators } from "utils/constants/operators"
import FormElement from "components/Form/FormElement"

import { PageCollection } from "../../../components/Elements/PDFViewer"
import { isFrenchLanguage } from "utils/i18n"
import "./CGUModal.scoped.scss"

const defaultFormFields = {
	authorization: false,
}

export const CGUModal = (
    { 
        operator,
        callbackAndSend,
        
    }
) => {
    const [formFields, setFormFields] = React.useState(defaultFormFields)
    const [errors, setErrors] = React.useState([])
    const [showLocalErrors, setShowLocalErrors] = React.useState(false)

    const { hideModal } = useModal()
    const { t } = useTranslation()

    const languageExtension = isFrenchLanguage() ? "FR" : "EN"

    const validateAndSend = (response) => {
        const formReady = !(errors.length > 0)

		if (!formReady) {
			setShowLocalErrors(true)
		} else {
            hideModal()
            callbackAndSend(response)
            // Reset field to false. Important if we have two CGUs to signed
            setFormFields(s => ({
                ...s,
                authorization: false
            }))
        }
    }

    const handleInputChange = React.useCallback(
        (event) => {
            const target = event.target
            const value = target.type === "checkbox" ? target.checked : target.value
            const name = target.name
            setFormFields(s => ({
                ...s,
                [name]: value
            }))
        }, []
    )

    const handleValidation = React.useCallback((name, errs) => {
        setErrors((s) => {
            const cleanErrors = [...s.filter((e) => e.origin !== name)]
            return [
                ...cleanErrors,
                ...errs
            ]
        })
    }, [])

    const documentName = operators.find((operatorItem) => operatorItem.id_api === operator)?.cguDocumentName    

    return (
        <div className="p-12 c-modal-cgu">
            <h2 className="c-h2 text-primary text-xl font-bold text-center mt-7 mb-7">{t("cgu.title", { ns: "partner" })}</h2>
            <div className="c-modal-cgu__pdf">
                {documentName && <PageCollection pdf={documentName[languageExtension]} />}
            </div>
            
            <FormElement
                value={formFields.authorization}
                name="authorization"
                type="checkbox"
                checkboxLabel={t("cgu.checkbox_label", { ns: "partner" })}
                className="p-7"
                required="true"
                showErrors={showLocalErrors}
                onValidate={handleValidation}
                onChange={handleInputChange}
            />

            <div className="flex flex-center flex-col mt-5">
                <button
                    type="button"
                    className="c-btn c-btn--primary px-7 mb-5 lg:m-0"
                    onClick={validateAndSend}
                >
                    {t("global.confirm")}
                </button>
            </div>
        </div>
    )
}